import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import { authApi } from 'api/authApi'
import clientsApi from 'api/clientsApi'
import developerApi from 'api/developerApi'
import projectApi from 'api/projectApi'
import plotApi from 'api/plotApi'
import bookingApi from 'api/bookingApi'
import paymentApi from 'api/paymentApi'
import documentApi from 'api/documentApi'
import notificationApi from 'api/notificationApi'
import reportApi from 'api/reportApi'
import brokerApi from 'api/brokerApi'
import customerApi from 'api/customerApi'
import tenantApi from 'api/tenantApi'
import userAdminApi from 'api/userAdminApi'
import lookupApi from 'api/lookupApi'
import moduleConfigApi from 'api/moduleConfigApi'
import taskApi from 'api/taskApi'
import communicationApi from 'api/communicationApi'
import rootReducer, { RootState } from './rootReducer'

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      clientsApi.middleware,
      developerApi.middleware,
      projectApi.middleware,
      plotApi.middleware,
      bookingApi.middleware,
      paymentApi.middleware,
      documentApi.middleware,
      notificationApi.middleware,
      reportApi.middleware,
      brokerApi.middleware,
      customerApi.middleware,
      tenantApi.middleware,
      userAdminApi.middleware,
      lookupApi.middleware,
      moduleConfigApi.middleware,
      taskApi.middleware,
      communicationApi.middleware
    )
})

export type AppDispatch = typeof store.dispatch
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>

export default store
